/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Component} from '@angular/core';
import {SubscriptionTypeDetailsService} from "../services/subscription-type-details.service";
import {SubscriptionTypeNewService} from "./subscription-type-new.service";

@Component({
  selector: 'well-subscription-type-add-page',
  templateUrl: './subscription-type-add-page.component.html',
  styleUrls: ['./subscription-type-add-page.component.scss'],
  providers: [{ provide: SubscriptionTypeDetailsService, useClass: SubscriptionTypeNewService }]
})
export class SubscriptionTypeAddPageComponent {

}
